import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useStoreShareFunction } from "../../store/StoreShareFunction";
import "../../styles/components/addResidencePart/step13.css";

const currentStep = 13;

export default function Step13FinishPublish({
  step,
  handleBlockBtn,
  setConditions,
  conditions,
}) {
  const { t } = useTranslation();
  useEffect(() => {
    if (currentStep == step) handleBlockBtn(conditions == false);
  }, [step, conditions]);

  const checkIfBlock = () => {
    return conditions == false;
  };
  const handleKeyDown = (e) => {
    if (e.key == "Enter" && currentStep == step && !checkIfBlock()) {
      document.activeElement.blur();
      useStoreShareFunction.getState().nextPage();
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [checkIfBlock, step, conditions]);
  return (
    <section
      className={`step-1-annonce step-13 ${
        currentStep == step ? "visible" : ""
      } 
          ${currentStep < step ? "go-top" : ""} ${
        currentStep > step ? "go-bottom" : ""
      } add-resi add-resi-input | relve`}
    >
      <div className="contains |  max-container flrow liner">
        <div className="left-part-add-resi | flcolm jcenter">
          <div className="content | flcolm jcenter">
            <span className="step">{t("addResidence.step13.title")}</span>
            <label>{t("addResidence.step13.label")}</label>
            <p>{t("addResidence.step13.description")}</p>
          </div>
        </div>
        <div className="right-part-add-resi | flcolm jcenter liner">
          <div className="content | flcolm addgap16">
            <p>{t("addResidence.step13.description1")}</p>
            <p>{t("addResidence.step13.description2")}</p>
            <button
              onClick={() => setConditions(!conditions)}
              className="btn | flrow liner"
            >
              <div className="card-coche | flex liner jcenter">
                {conditions && <span></span>}
              </div>
              <span>{t("addResidence.step13.acceptTxt")}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
